module.exports = __webpack_public_path__ + "static/_0005_BOLEMAN-b28d47ab2a13a480c69f93e311352ada.jpg";